import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';

// Components
import AppIcon from '../../components/AppIcon';

export class InvitationsSubMenuItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  onClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect();
  }

  render() {
    const { invitations, t } = this.props;

    return (
      <button type='button' onClick={this.onClick}
        style={{display: 'flex', alignItems: 'center', gap: 10, width: '100%',
          border: 0, background: 'transparent', color: 'inherit', cursor: 'pointer',
          padding: '0.6em 0.8em', textAlign: 'left'}}>
        <span className='br-chip' style={{margin: 0, borderRadius: '50%'}}>
          {invitations.length}
        </span>
        <span>{t('Invitations')}</span>
        <AppIcon name='chevron right' style={{marginLeft: 'auto'}} aria-hidden='true' />
      </button>
    );
  }
}

export default withTranslation()(InvitationsSubMenuItem);
